<template>

    <ui-login-layout
        @login="login"
        :loading="loading"
        :footer="false"
        :header="false">

        <div class="logo-holder" slot="form-header">
            <i class="svg logo-delta-project"></i>
        </div>

    </ui-login-layout>

</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';

import EmailAccountType from 'app/auth/EmailAccountType';

@Component({

    name: 'Login'
})
export default class Login extends Vue
{
    loading = false;

    async login(username, password){

        if(!username || !password){

            this.$toast.error('Voer uw gebruikersnaam en wachtwoord in');
            return;
        }

        this.loading = true;
        this.logger.info(`Logging in ${username}`);

        try {

            await this.$auth.login(EmailAccountType.NAME, { username, password });

            this.$router.replace({ name: this.$di.config.homeRoute });
        }
        catch(e){

            this.logger.error('Error logging in', e);
            this.$toast.error('Onjuiste inloggegevens, probeer het opnieuw.');
        }

        this.loading = false;
    }
}

</script>